document.addEventListener('DOMContentLoaded' , () =>{
    // order - order-write-page
	/*
    if(document.querySelector('.order-write-page')){
        const paymentItem = document.querySelectorAll('.payment__item');

        paymentItem.forEach(function(el){
            el.addEventListener('click' , function(){
				document.querySelector('.benefit-content.kakao').classList.remove('active');
				document.querySelector('.benefit-content.payco').classList.remove('active');

                if(el.classList.contains('benefit')){
					if(el.classList.contains('kakaopay')){
						document.querySelector('.benefit-content.kakao').classList.add('active');
					}else{
						document.querySelector('.benefit-content.payco').classList.add('active');
					}
                }
            });
		})
    };
	*/
});
